module.exports = __webpack_public_path__ + "static/media/highlightCenter_hyperboloid.79213154.png";